import axios from "axios";

const BASE_URL = "https://backend.maamaas.com/promotions";

export const PromotionsService = {

    // ================================
    // CREATE HELPDESK TICKET
    // ================================
    createTicket: async (ticketData, file) => {

        const token = localStorage.getItem("authToken");

        if (!token) {
            throw new Error("No auth token found. Please login again.");
        }

        const formData = new FormData();

        const ticketBlob = new Blob(
            [JSON.stringify(ticketData)],
            {
                type: "application/json",
            }
        );

        formData.append("ticket", ticketBlob);

        if (file) {
            formData.append("attachmentUrl", file);
        }

        try {

            const response = await axios.post(
                `${BASE_URL}/api/user/helpdesk/create`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            return response;

        } catch (error) {

            console.error(
                "Create ticket error:",
                error.response?.data || error.message
            );

            throw error;
        }
    },


    // ================================
    // CREATE OVERVIEW
    // ================================
    createOverview: async (overviewData, imageFiles = []) => {

        const token = localStorage.getItem("authToken");

        if (!token) {
            throw new Error("No auth token found. Please login again.");
        }

        const formData = new FormData();

        // Same body shape as updateOverview: spread whatever was passed in,
        // and only fall back to "OVERVIEW" if no type was supplied.
        // This lets Digital Screens (and Branding/Leads/Offers) send their
        // own type instead of always being forced to "OVERVIEW".
        const overviewPayload = {
            title: overviewData.title,
            description: overviewData.description,
            type: overviewData.type || "OVERVIEW",
            featureDescription: overviewData.featureDescription || [],
        };

        const overviewBlob = new Blob(
            [JSON.stringify(overviewPayload)],
            { type: "application/json" }
        );

        formData.append("overview", overviewBlob);

        if (Array.isArray(imageFiles)) {
            imageFiles.forEach((file) => {
                if (file instanceof File) {
                    formData.append("images", file);
                }
            });
        }

        try {
            const response = await axios.post(
                `${BASE_URL}/api/admin/overview/create`,
                formData,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            return response;

        } catch (error) {
            console.error(
                "Create overview error:",
                error.response?.data || error.message
            );
            throw error;
        }
    },


    // ================================
    // GET SUBSCRIPTION PLANS
    // ================================
    getSubscriptionPlans: async () => {

        const token = localStorage.getItem("authToken");

        try {

            const response = await axios.get(
                `${BASE_URL}/api/subscription/plans`,
                {
                    headers: token
                        ? {
                            Authorization: `Bearer ${token}`,
                        }
                        : {},
                }
            );

            return response.data;

        } catch (error) {

            console.error(
                "Get subscription plans error:",
                error.response?.data || error.message
            );

            throw error;
        }
    },


    // ================================
    // GET VENDOR TICKETS
    // ================================
    getVendorTickets: async () => {

        const token = localStorage.getItem("authToken");
        const vendorId = localStorage.getItem("vendorId");

        if (!token) {
            throw new Error("No auth token found.");
        }

        if (!vendorId) {
            throw new Error("No vendor ID found.");
        }

        try {

            const response = await axios.get(
                `${BASE_URL}/api/user/helpdesk/vendor/${vendorId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            return response.data;

        } catch (error) {

            console.error(
                "Get vendor tickets error:",
                error.response?.data || error.message
            );

            throw error;
        }
    },




    // Get all Overview promotions
    getOverviews: async () => {
        const token = localStorage.getItem("authToken");

        try {
            const response = await axios.get(
                `${BASE_URL}/api/overviews/get`,
                {
                    headers: token
                        ? {
                            Authorization: `Bearer ${token}`,
                        }
                        : {},
                }
            );

            return response.data;

        } catch (error) {
            console.error(
                "Failed to fetch overviews:",
                error.response?.data || error.message
            );

            throw error;
        }
    },

    updateOverview: async (id, overviewData, imageFiles = []) => {
        const token = localStorage.getItem("authToken");

        if (!token) {
            throw new Error("No auth token found. Please login again.");
        }

        const formData = new FormData();

        const blob = new Blob(
            [
                JSON.stringify({
                    ...overviewData,
                    id: id,
                    type: overviewData.type
                }),
            ],
            {
                type: "application/json",
            }
        );

        formData.append("overview", blob);

        // Add new images if selected
        imageFiles.forEach((file) => {
            formData.append("images", file);
        });

        try {
            const response = await axios.put(
                `${BASE_URL}/api/overview/update/${id}`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            return response.data;

        } catch (error) {
            console.error(
                "Failed to update overview:",
                error.response?.data || error.message
            );

            throw error;
        }
    },
};